var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortingArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90381 1.42679L4.20508 5.19876C4.08057 5.3306 4 5.52103 4 5.68216C4 6.07035 4.26367 6.33402 4.64453 6.33402C4.83496 6.33402 4.98145 6.2681 5.10596 6.14359L6.62939 4.56888L7.80859 3.20658L7.73535 4.89847V14.3101C7.73535 14.6983 8.00635 14.9693 8.39453 14.9693C8.77539 14.9693 9.04639 14.6983 9.04639 14.3101V4.89847L8.98047 3.20658L10.1523 4.56888L11.6831 6.14359C11.8076 6.2681 11.9468 6.33402 12.1372 6.33402C12.5181 6.33402 12.7817 6.07035 12.7817 5.68216C12.7817 5.52103 12.7085 5.3306 12.5767 5.19876L8.88525 1.42679C8.61426 1.14115 8.18213 1.1265 7.90381 1.42679Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortingArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SortingArrow.943b7307a481a8ac98eba5d20e57606b.svg";